import {z} from 'zod';
import {requisitionDate} from './requisitions';
const id=z.string().min(1).max(150);
const text=z.string().trim().max(4000).default('');
export const ncrEightDSchema=z.object({d1:text,d2:text,d3:text,d4:text,d5:text,d6:text,d7:text,d8:text});
export const ncrDraftSchema=z.object({
 requestId:z.string().uuid(),
 sourceKind:z.enum(['Iqc','SubcontractInspection','ProductionInspection']),
 sourceId:id,
 title:z.string().trim().min(5).max(200),
 notes:z.string().trim().max(2000).default(''),
 eightD:ncrEightDSchema.default({d1:'',d2:'',d3:'',d4:'',d5:'',d6:'',d7:'',d8:''}),
});
export const ncrUpdateSchema=ncrDraftSchema.and(z.object({revision:z.number().int().positive()}));
/**
 * Ba đường ra khỏi một NCR — tờ "P 流程" vẽ đúng ba, không hơn không kém.
 *
 * `Rework`     — làm lại: lô quay về nấc sản xuất và sinh một lượt kiểm mới.
 * `Scrap`      — loại bỏ: lô không đi tiếp.
 * `Concession` — CHO QUA CÓ PHÊ DUYỆT: lô đã trượt nhưng vẫn được giao.
 *
 * Đường thứ ba là đường duy nhất đưa hàng đã trượt tới khách hàng cuối, nên nó
 * chịu thêm hai điều kiện dưới đây mà hai đường kia không chịu.
 */
export const NCR_DISPOSITIONS=['Rework','Scrap','Concession'] as const;
export type NcrDisposition=typeof NCR_DISPOSITIONS[number];
export const ncrActionSchema=z.object({
 revision:z.number().int().positive(),
 action:z.enum(['open','close','cancel']),
 reason:z.string().trim().min(5).max(1000),
 eightD:ncrEightDSchema.optional(),
 /** Bắt buộc khi `action==='close'`; vô nghĩa với mở và huỷ. */
 disposition:z.enum(NCR_DISPOSITIONS).optional(),
 /** Ô tick riêng cho đường "cho qua" — xem refine bên dưới. */
 concessionAcknowledged:z.boolean().default(false),
})
 .refine(v=>v.action!=='close'||v.disposition!==undefined,'ncr_disposition')
 .refine(v=>v.action==='close'||v.disposition===undefined,'ncr_disposition')
 /**
  * CHO QUA phải có xác nhận RIÊNG, không gộp vào ô lý do.
  *
  * Một ô văn bản bắt buộc thì người vội sẽ gõ "ok" cho xong. Một ô tick tách
  * riêng buộc người ký dừng lại một nhịp và nói thành lời rằng mình biết đang
  * cho hàng đã trượt đi tiếp. Cùng mẫu với `deviationAcknowledged` của phiếu
  * kiểm, và cùng lý do.
  */
 .refine(v=>v.disposition!=='Concession'||v.concessionAcknowledged,'ncr_concession_unacknowledged')
 /** Và phải viết ra vì sao — 5 ký tự đủ cho "đóng", không đủ cho việc này. */
 .refine(v=>v.disposition!=='Concession'||v.reason.trim().length>=20,'ncr_concession_reason');
export const supplierAssessmentDraftSchema=z.object({requestId:z.string().uuid(),supplierId:id,periodFrom:requisitionDate,periodTo:requisitionDate,notes:z.string().trim().max(2000).default('')}).refine(v=>v.periodFrom<=v.periodTo);
export type NcrDraftInput=z.infer<typeof ncrDraftSchema>;
export type NcrActionInput=z.infer<typeof ncrActionSchema>;
export type SupplierAssessmentInput=z.infer<typeof supplierAssessmentDraftSchema>;
export type NcrEightD=z.infer<typeof ncrEightDSchema>;
export interface NcrSourceSnapshot {kind:'Iqc'|'SubcontractInspection'|'ProductionInspection';sourceId:string;supplierId:string|null;supplierName:string;productId:string;productCode:string;lotNumber:string;rejectedQuantity:string;unit:string;label:string;}
export interface NcrDto {
 id:string;documentNo:string;status:'Draft'|'Open'|'Closed'|'Cancelled';revision:number;title:string;notes:string;
 /** Cách lô này kết thúc; `null` khi NCR chưa đóng. */
 disposition:NcrDisposition|null;
 /** Người ký đã khẳng định rõ khi cho qua một lô đã trượt. */
 concessionAcknowledged:boolean;
 source:NcrSourceSnapshot;eightD:NcrEightD;createdAt:number;
 events:{action:string;reason:string;createdAt:number;createdBy:string|null}[];
}
export interface SupplierAssessmentSnapshot {
 periodFrom:string;periodTo:string;
 iqcReports:number;iqcAcceptedUnits:number;iqcRejectedUnits:number;
 ncrOpen:number;ncrClosed:number;
 sources:{iqc:'iqc_dispositions';ncr:'ncr_documents'};
}
export interface SupplierAssessmentDto {
 id:string;documentNo:string;supplierId:string;supplierName:string;periodFrom:string;periodTo:string;notes:string;
 snapshot:SupplierAssessmentSnapshot;createdAt:number;
}
